import React from 'react'
import PropTypes from 'prop-types'
import NativeListener from 'react-native-listener'
import cx from 'classnames'

import Input from 'components/forms/Input/Input'

import messages from './messages'
import s from './SearchInput.scss'


const SearchInput = (props) => {
  const { id, valueLink, isFocused, isMobile, isNewMobileViewVisible, isDesktop, isFetching, onFocus, onTouchStart } = props

  const inputClassName = cx({
    [s.input]: !isNewMobileViewVisible,
    [s.newInput]: isNewMobileViewVisible,
    [s.isDesktop]: isDesktop,
  })

  const rootClassName = cx(s.inputRoot, {
    [s.isFocused]: isFocused && isDesktop,
  })

  const searchInputNode = (
    <Input
      id={id}
      type="text"
      rootClassName={rootClassName}
      inputClassName={inputClassName}
      placeholder={messages.placeholder}
      valueLink={valueLink}
      withLoader={isFetching}
      rightLoader
      onFocus={onFocus}
      onTouchStart={onTouchStart}
      data-id="searchInput"
      tabIndex={-1}
    />
  )

  // form with non-empty action is required by iOS 9+ to change keyboard type to 'Search'
  return (
    <NativeListener onClick={(event) => event.stopPropagation()}>
      {
        isMobile ? (
          <form
            action="."
            onSubmit={(event) => {
              event.preventDefault()
              return false
            }}
          >
            {searchInputNode}
          </form>
        ) : (
          searchInputNode
        )
      }
    </NativeListener>
  )
}

SearchInput.propTypes = {
  id: PropTypes.string,
  valueLink: PropTypes.object,
  isMobile: PropTypes.bool,
  isNewMobileViewVisible: PropTypes.bool,
  onFocus: PropTypes.func,
  onTouchStart: PropTypes.func,
}


export default SearchInput
